module.exports = __webpack_public_path__ + "img/08.edcf8851.png";